import React, { useState, useEffect } from "react";
import Layouts from "../../Layouts";
import { IoLocationOutline, IoTrashOutline } from "react-icons/io5";
import CartBackground from "../../../Assests/images/CartBackground.png";
import Counter from '../../../Shared/Counter';
import { useDispatch, useSelector } from "react-redux";
import { increaseQtyDb, decreaseQtyDb, removeItemDb, selectTotalAmount, setClearCartItems, fetchCartListDb } from "../../../app/CartSlice";
import { useNavigate } from "react-router-dom";
// import { BsArrowLeft } from "react-icons/bs";
import Address from "../CartPage/Address";
import { Drawer, Input, Modal, Radio, message, Spin } from "antd";
import { TiPlus } from "react-icons/ti";
import { isAuthenticated, getCurrentUser } from "../../../utils/auth";
import LoginModal from "../../../Shared/LoginModal";
import CartPlaceService from "../../../Redux/Services/CartPlaceService";
import authService from "../../../Redux/Services/authService";


function CartPage() {
  const state = useSelector(state => state.cart.cartItems) || [];
  const cartTotal = useSelector(state => state.cart.cartTotalAmount) || 0;
  const dispatch = useDispatch();
  const deliveryCharge = state.length > 0 ? 20 : 0;
  const navigate = useNavigate();

  const subTotal = state.reduce((acc, it) => {
    const p = Number(it.selectedProductPrice ?? it.price ?? 0);
    const q = Number(it.cartQuantity) || 1;
    return acc + p * q;
  }, 0);

  const finalTotal = subTotal > 0 ? subTotal + deliveryCharge : 0;

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isOrderPlacedModalOpen, setIsOrderPlacedModalOpen] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);

  const handleProceedToPay = async () => {
    if (isAuthenticated()) {
      const user = getCurrentUser();
      const cartId = state[0]?.cartId;
      if (!cartId) {
        message.error("Unable to find your cart. Please add items again.");
        return;
      }

      setPaymentLoading(true);
      try {
        const payload = {
          cartId: cartId,
          createdBy: user?.userId || user?.userCode || localStorage.getItem("userCode") || "CUSTOMER",
          modifiedBy: user?.userId || user?.userCode || localStorage.getItem("userCode") || "CUSTOMER",
          paymentMode: "Cash",
          userId: user?.userId || user?.userCode || localStorage.getItem("userCode") || "CUSTOMER"
        };
        await CartPlaceService.cashPayment(payload);
        setIsOrderPlacedModalOpen(true);
      } catch (err) {
        console.error("Cash payment failed:", err);
        message.error(err?.response?.data?.message || "Checkout failed. Please try again.");
      } finally {
        setPaymentLoading(false);
      }
    } else {
      setIsLoginModalOpen(true);
    }
  };

  const handleLoginSuccess = () => {
    setIsLoginModalOpen(false);
    dispatch(fetchCartListDb());
    fetchAddresses();
    message.success("Logged in successfully! Please click Proceed to Pay to complete your order.");
  };

  const handleOrderPlacedModalClose = () => {
    dispatch(setClearCartItems());
    setIsOrderPlacedModalOpen(false);
    navigate('/product');
  };

  const handleProductsClick = () => {
    navigate('/product');
  };

  const [showAddressModal, setShowAddressModal] = useState(false); // State to control the visibility of the address modal

  const handleClick = (type, id) => {
    const item = state.find(it => it.cartItemId === id || it.id === id);
    if (type === 'increment') {
      dispatch(increaseQtyDb(id));
    } else if (type === 'decrement') {
      if (item) {
        if (item.cartQuantity > 1) {
          dispatch(decreaseQtyDb(item));
        } else {
          dispatch(removeItemDb(item));
        }
      }
    }
  };

  const handleItemDelete = (item) => {
    dispatch(removeItemDb(item));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const [selectedValue, setSelectedValue] = useState('');
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loadingAddresses, setLoadingAddresses] = useState(false);

  const fetchAddresses = async () => {
    const user = getCurrentUser();
    if (!user) return;
    const userId = user.userId || user.userCode || localStorage.getItem("userCode");
    if (!userId) return;

    setLoadingAddresses(true);
    try {
      const response = await authService.getAddress({ userId });
      if (response && response.data) {
        setAddresses(response.data);
        if (response.data.length > 0) {
          setSelectedAddress(response.data[0]);
          setSelectedValue(response.data[0].id || String(response.data[0].sno));
        }
      }
    } catch (err) {
      console.error("Failed to load addresses on CartPage:", err);
    } finally {
      setLoadingAddresses(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated()) {
      fetchAddresses();
    }
  }, []);

  const handleRadioChange = (e) => {
    const val = e.target.value;
    setSelectedValue(val);
    const found = addresses.find(addr => (addr.id || String(addr.sno)) === val);
    if (found) {
      setSelectedAddress(found);
    }
  };

  return (
    <Layouts>
      <div className="bg-white">
        <div className="relative">
          <img
            src={CartBackground}
            alt="cart"
            className="w-full h-52 mt-0 md:mt-8 object-cover"
          />
          <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl md:text-[50px] font-black text-white">
            My Cart
          </p>
        </div>
        {state.length === 0 ? (
          <div className="flex flex-col gap-4 justify-center items-center h-[50vh]">
            <h1 className="md:text-4xl text-xl font-medium text-productColour">Your Cart is empty</h1>
            <button
              className="border-2 border-popButtoncolour rounded-md bg-[#A17A17] text-white w-[200px] md:w-[250px] md:h-[60px] h-[40px] font-sans font-medium text-lg mt-5 hover:bg-[#85630e] transition-colors"
              onClick={handleProductsClick}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <div className="container text-pi md:flex justify-between px-6 gap-5 mt-5 mb-20">
            <div className="md:w-[60%] overflow-hidden">
              {state.map((item, idx) => {
                const itemPrice = Number(item.selectedProductPrice ?? item.price ?? 0);
                const itemQty = Number(item.cartQuantity) || 1;
                const itemTotal = itemPrice * itemQty;
                const sizeLabel =
                  typeof item.selectedSize === "object" && item.selectedSize?.packageSize
                    ? item.selectedSize.packageSize
                    : typeof item.selectedSize === "string"
                    ? item.selectedSize
                    : "Standard";
                const baseUrl = (process.env.REACT_APP_IMAGE_URL || "").trim();
                const imageSrc = item.productImage
                  ? item.productImage.startsWith("http") || item.productImage.startsWith("data:")
                    ? item.productImage
                    : `${baseUrl}${item.productImage}`
                  : "";

                return (
                  <div
                    key={item.cartItemId || item.id || idx}
                    className="justify-between md:mb-6 mb-4 rounded-lg border drop-shadow-xl bg-white md:p-6 p-4 sm:flex sm:justify-start"
                  >
                    <img
                      src={imageSrc}
                      alt={item.name || "product"}
                      className="rounded-lg w-48 mx-auto object-contain h-48"
                    />
                    <div className="md:ml-10 flex w-full justify-between">
                      <div className="mt-2 sm:mt-0">
                         <h2 className="md:text-lg text-base font-sans font-medium text-gray-900 break-words max-w-[200px] md:max-w-md">
                           {item.name ? item.name.replace(/_/g, ' ') : ''}
                         </h2>
                        <h2 className="mt-2 text-lg text-green-900 font-medium">{sizeLabel}</h2>
                        <div className="mt-2">
                          <p className="text-lg font-sans font-semibold text-[#A17A17]">
                            INR {itemPrice}
                            {itemQty > 1 && (
                              <span className="text-sm font-normal text-gray-500 ml-2">
                                (Total: INR {itemTotal})
                              </span>
                            )}
                          </p>
                        </div>
                        <div className="mt-3">
                          <Counter
                            counter={itemQty}
                            handleClick={handleClick}
                            id={item.cartItemId || item.id}
                          />
                        </div>
                      </div>
                      <div className="mt-3 flex justify-between sm:space-y-6 sm:mt-0 sm:block sm:space-x-6">
                        <IoTrashOutline
                          className="text-3xl hover:cursor-pointer text-red-700 hover:text-red-900 transition-colors"
                          onClick={() => handleItemDelete(item)}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="md:w-[30%]">
              <div className="border rounded-lg shadow-md bg-[#FFF0C0] p-3">
                <div className="flex gap-1">
                  <IoLocationOutline className="mt-1 text-[20px]" />
                  <h3 className="text-xl font-medium">Delivery Address</h3>
                </div>
                <hr className="my-1 border-b-2 border-gray-500" />
                 <div className="mt-2 text-sm text-gray-700 leading-relaxed">
                   {selectedAddress ? (
                     <>
                       <p className="font-bold text-gray-900">{selectedAddress.name}</p>
                       <p className="font-medium text-gray-800">{selectedAddress.mobileNumber}</p>
                       <p>{selectedAddress.address1} {selectedAddress.address2 ? `, ${selectedAddress.address2}` : ""} {selectedAddress.landmark ? `, Landmark: ${selectedAddress.landmark}` : ""}, {selectedAddress.city}, {selectedAddress.state}, {selectedAddress.country} - {selectedAddress.pincode}</p>
                     </>
                   ) : (
                     <p className="text-gray-500 italic">No delivery address selected. Please change or add an address.</p>
                   )}
                 </div>
                <div className="flex justify-center items-center">
                  <button
                    className="mt-2 border h-12 w-full mx-4 text-xl font-medium border-popButtoncolour bg-[#A17A17] text-white rounded-lg font-sans hover:bg-[#85630e] transition-colors"
                    onClick={showDrawer}
                  >
                    Change Address
                  </button>
                </div>
              </div>

              <div className="rounded-lg border bg-[#FFF0C0] p-6 mt-8 shadow-md">
                <div className="bg-popUpgreen p-3 flex justify-between items-center">
                  <input placeholder="Avail Coupons" className="p-2 w-full" />
                  <button onClick={showModal} className="border bg-[#A17A17] p-2 rounded-md text-white hover:bg-[#85630e]">
                    Apply
                  </button>
                </div>

                <div className="mb-2">
                  <h2 className="flex justify-center text-xl text-[#404040] font-bold">Cart Total</h2>
                  <div className="mt-3 flex justify-between font-medium">
                    <p className="text-gray-700">Subtotal</p>
                    <p className="text-gray-700 font-semibold">INR {subTotal}</p>
                  </div>
                </div>
                <div className="flex justify-between font-medium">
                  <p className="text-gray-700">Shipping</p>
                  <p className="text-gray-700 font-semibold">INR {deliveryCharge}</p>
                </div>
                <hr className="my-4" />
                <div className="flex justify-between mb-3">
                  <p className="text-lg font-bold">Total</p>
                  <div>
                    <p className="mb-1 text-lg font-bold text-[#A17A17]">INR {finalTotal}</p>
                  </div>
                </div>
                <div className="flex justify-center">
                  <button
                    onClick={handleProceedToPay}
                    disabled={paymentLoading}
                    className={`border rounded w-full p-2 border-popButtoncolour bg-[#A17A17] hover:bg-[#85630e] text-white text-xl font-sans font-medium transition-colors ${paymentLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                  >
                    {paymentLoading ? 'Processing...' : 'Proceed To Pay'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Login Modal for authentication check on Proceed to Pay */}
        <LoginModal
          isOpen={isLoginModalOpen}
          onClose={() => setIsLoginModalOpen(false)}
          onLoginSuccess={handleLoginSuccess}
        />

        {/* Order Placed Success Modal */}
        <Modal
          open={isOrderPlacedModalOpen}
          onCancel={handleOrderPlacedModalClose}
          footer={null}
          centered
          closable={true}
          maskClosable={false}
          width={450}
          bodyStyle={{ padding: 0 }}
        >
          <div className="flex flex-col items-center text-center p-8 bg-white rounded-3xl">
            {/* Beautiful Success Animation/Icon */}
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6 animate-bounce">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="#10B981"
                className="w-10 h-10"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>

            {/* Title */}
            <h2 className="text-2xl font-serif font-black text-gray-900 mb-4 tracking-wide">
              Order Placed Successfully!
            </h2>

            {/* Content */}
            <p className="text-sm md:text-base text-gray-600 font-medium leading-relaxed mb-8 px-2">
              Payment link will be sent to your registered mobile number, make the payment through the link to initiate the delivery process.
            </p>

            {/* Dismiss Button */}
            <button
              onClick={handleOrderPlacedModalClose}
              className="w-full py-3.5 bg-gradient-to-r from-[#A17A17] to-[#B88E28] hover:from-[#8C6913] hover:to-[#A17A17] text-white font-bold text-base rounded-2xl shadow-md hover:shadow-lg transition-all duration-200 transform hover:-translate-y-0.5 active:translate-y-0 cursor-pointer"
            >
              Continue Shopping
            </button>
          </div>
        </Modal>
        <Drawer title={<span className="uppercase text-white">Select Delivery Address</span>} onClose={onClose} open={open}>
          <div>
            <Address visible={showAddressModal} onCancel={() => setShowAddressModal(false)} onSuccess={fetchAddresses} />
            <div className="flex gap-2 mb-4">
              <TiPlus className="mt-1" />
              <label className="uppercas cursor-pointer font-bold text-primaryColor hover:opacity-80" onClick={() => setShowAddressModal(true)}>Add New Address</label>
            </div>
            {loadingAddresses ? (
              <div className="flex justify-center py-6">
                <Spin size="small" />
              </div>
            ) : addresses.length === 0 ? (
              <p className="text-gray-500 italic text-center py-4">No addresses saved yet. Click Add New Address above to save one.</p>
            ) : (
              addresses.map((address) => {
                const addrId = address.id || String(address.sno);
                const fullAddressText = `${address.address1} ${address.address2 ? `, ${address.address2}` : ""} ${address.landmark ? `, Landmark: ${address.landmark}` : ""}, ${address.city}, ${address.state}, ${address.country} - ${address.pincode}`;
                return (
                  <div key={addrId} className="flex border-b border-gray-150 py-3 mt-3 items-start">
                    <div className="w-[10%] pt-1">
                      <Radio
                        className="cursor-pointer"
                        value={addrId}
                        onChange={handleRadioChange}
                        checked={selectedValue === addrId}
                      />
                    </div>
                    <div className="w-[90%] min-w-0">
                      <div className="flex gap-4 items-center flex-wrap">
                        <p className="text-base font-bold text-gray-800">{address.name}</p>
                        <p className="rounded-full px-2 py-0.5 text-xs text-center bg-popButtoncolour text-white uppercase">{address.addressType || "HOME"}</p>
                      </div>
                      <p className="text-sm font-semibold text-gray-700 mt-1">{address.mobileNumber}</p>
                      <p className="text-xs text-gray-600 mt-1 leading-relaxed">{fullAddressText}</p>

                      {selectedValue === addrId && (
                        <div className="flex w-full mt-3">
                          <button 
                            className="border p-2 w-full rounded-md bg-[#A17A17] text-white font-medium hover:bg-[#85630e] transition-colors cursor-pointer"
                            onClick={onClose}
                          >
                            Deliver to this Address
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </Drawer>
      </div>
    </Layouts>
  );
}

export default CartPage;













